import { render } from "./PuntosVenta.vue?vue&type=template&id=48555653"
import script from "./PuntosVenta.vue?vue&type=script&lang=js"
export * from "./PuntosVenta.vue?vue&type=script&lang=js"

import "./PuntosVenta.vue?vue&type=style&index=0&id=48555653&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__